// Autogenerated file
export const entityTypesEnum = {
    Cargo: "Cargo",
    TruckingBid: "TruckingBid",
    CargoOwnerBid: "CargoOwnerBid",
    ForwarderBid: "ForwarderBid",
    BidPoint: "BidPoint",
    DistributionBid: "DistributionBid",
    DistributionBidCargo: "DistributionBidCargo",
    DistributionBidPoint: "DistributionBidPoint",
};
export const entityTypes = [
    { label: "Груз", value: "Cargo" },
    { label: "Заявка транспортной организации", value: "TruckingBid" },
    { label: "Заявка грузовладельца", value: "CargoOwnerBid" },
    { label: "Заявка экспедитора", value: "ForwarderBid" },
    { label: "Точка заявки", value: "BidPoint" },
    { label: "Заказ", value: "DistributionBid" },
    { label: "Груз заказа", value: "DistributionBidCargo" },
    { label: "Точка заказа", value: "DistributionBidPoint" },
];
